import { render, staticRenderFns } from "./index.vue?vue&type=template&id=533f7d59"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/kft.ycxxkj.com/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533f7d59')) {
      api.createRecord('533f7d59', component.options)
    } else {
      api.reload('533f7d59', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=533f7d59", function () {
      api.rerender('533f7d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-title/index.vue"
export default component.exports